import { LineItemEntity } from "~/interfaces/entities/LineItem"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: lineItems,
  selectors: lineItemsSelectors,
} = createEntitySlice<LineItemEntity>("lineItems")
